module.exports = __webpack_public_path__ + "static/media/confirmar-limpar.79421070.png";